import Image from 'next/image';
import styled, { css, RuleSet } from 'styled-components';
import { Breakpoints } from '../../../styled/constants';
import { FlexCenterAligned } from '../../../styled/common';
import { Typography } from '../Typography';
import { animation } from '../../../styled/placeholders.styled';

export const GalleryCarouselContainer = styled.div<{
  $photosCount: number;
  $styles?: RuleSet<object>;
  $limit: number;
  $carouselPhotoWidth: number;
  $hideFromWidth?: string;
}>`
  margin-top: 5px;

  display: grid;
  gap: 9px;
  grid-template-columns: ${({ $photosCount, $limit, $carouselPhotoWidth }) => {
    if ($limit && $photosCount >= $limit) {
      return `repeat(${$limit}, 1fr)`;
    }
    return `repeat(${$photosCount}, ${$carouselPhotoWidth}px)`;
  }};
  overflow-x: hidden;
  overflow-y: hidden;
  pointer-events: none;

  scroll-behavior: smooth;
  position: relative;

  & > * {
    pointer-events: auto;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    gap: 5px;
  }

  ${({ $hideFromWidth }) =>
    $hideFromWidth &&
    css`
      @media (max-width: ${$hideFromWidth}) {
        display: none;
      }
    `}

  ${({ $styles }) => $styles};
`;

export const GalleryCarouselImageWrapper = styled.div`
  width: 100%;
  height: 50px;
  cursor: pointer;

  &:last-of-type {
    position: relative;
  }
`;

export const GalleryCarouselImage = styled(Image)<{ $isActive: boolean }>`
  width: 100%;
  border-radius: 7px;
  transition: opacity 0.1s;
  object-fit: cover;
  ${animation};

  ${({ $isActive }) =>
    !$isActive &&
    css`
      opacity: 0.7;
    `}
`;

export const Overlay = styled(FlexCenterAligned)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 7px;
`;

export const OverlayText = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.white};
`;
